import React from "react";
import Counter from "./hooks/setCount";

export default function App() {
  return (
    <div>
      <Counter />
    </div>
  );
}
